import classNames from 'classnames'
import {ImgButton} from '../button'
import CustomSelect from '../customSelect'

const SelectedActions = ({isDarkMode, actions}) => {
    return (
        <div className={classNames('selected-actions', {
            dark: isDarkMode
        })}>
            {actions.map((action, index) => {
                switch (action.type) {
                case 'select':
                    return (
                        <div
                            key={index}
                            className={classNames('action-select', {
                                'cursor-not-allowed': action.disabled
                            })}
                        >
                            <CustomSelect
                                {...action.props}
                                placeholder={action.label}
                                isDisabled={action.disabled}
                                value={action.value || null}
                                onChange={(_, value) => action.onChange?.(value)}
                            />
                        </div>
                    )

                case 'button':
                default:
                    return (
                        <ImgButton
                            key={index}
                            className={classNames({
                                'light-bg': !isDarkMode,
                                [action?.className]: !!action?.className
                            })}
                            disabled={action.disabled}
                            onClick={action.onClick}
                        >
                            {action.icon}
                            {action.label && <span className="button-text">{action.label}</span>}
                        </ImgButton>
                    )
                }
            })}
        </div>
    )
}

export default SelectedActions
